// TODO: Refactor IT!
const IS_CHECKOUT = () => window.location.href.includes('checkout') || window.location.href.includes('cabinet/orders')
const IS_CHECKOUT_SUCCESS = () => window.location.href.includes('/checkout/success') || window.location.href.includes('cabinet/orders')

const IS_MANAGER_CHECKOUT = window.location.href.includes('/manager-checkout')
const IS_PRODUCT = window.location.href.includes('/tovar')
const IS_SERVICES = window.location.href.includes('/garantia-i-servisu')
const IS_SHOPS = window.location.href.includes('/shops')

const USER_DATA_KEY = 'userData'
const ANALYTICS_USER_ID_KEY = 'analyticsUserId'

const USER_TYPE = {
  MANAGER: 'manager',
  CUSTOMER: 'customer'
}

const MANAGER_TYPE = {
  CONTACT_CENTER_MANAGER: 'contact_center_manager',
  SELLER_FM_MANAGER: 'seller_fm_manager',
  ACCOUNT_MANAGER: 'account_manager',
  FRANCH_SALE_MANAGER: 'franch_sale_manager',
  PROFESSIONAL_SEGMENT_MANAGER: 'professional_segment_manager'
}

const TRANSLATIONS_PARAMS = {
  LANGUAGE: window.translationParams.language,
  LANGUAGE_PREFIX: window.translationParams.language === 'pl' ? '' : '/' + window.translationParams.language
}

const MAP_PLACEMENTS = {
  SHOPS: 'shops',
  SERVICES: 'services'
}

const SHOPS_OPENED_STATUSES = {
  CLOSE: 0,
  OPEN: 1,
  WILL_CLOSE: 2
}

const SHOPS_FILTERS_FLAGS = {
  SERVICES: 'services',
  OPENED: 'opened',
  NEAR_SUBWAY: 'near_subway'
}

const COMMENTS = {
  GET_PRODUCT_COMMENTS_ENDPOINT: '/shop/catalog/get-product-comments/',
  GET_COMPANY_COMMENTS_ENDPOINT: '/shop/catalog/get-company-comments/',
  ADD_PRODUCT_COMMENT_ENDPOINT: '/shop/catalog/add-comment/',
  ADD_COMPANY_COMMENT_ENDPOINT: '/shop/catalog/add-comment-company/',
  FORM_TYPE_PRODUCT: 'product',
  FORM_TYPE_COMPANY: 'company',
  FORM_TYPE_ANSWER: 'answer'
}

const QUESTIONS = {
  GET_QUESTIONS_TAGS_ENDPOINT: '/shop/catalog/get-question-tag-cloud/',
  GET_PRODUCT_QUESTIONS_ENDPOINT: '/shop/catalog/get-product-questions/',
  GET_COMPANY_QUESTIONS_ENDPOINT: '/shop/catalog/get-company-questions/',
  ADD_PRODUCT_QUESTION_ENDPOINT: '/shop/catalog/add-question/',
  ADD_COMPANY_QUESTION_ENDPOINT: '/shop/catalog/add-question-company/',
  FORM_TYPE_PRODUCT: 'product',
  FORM_TYPE_COMPANY: 'company',
  FORM_TYPE_ANSWER: 'answer'
}

const CART_STATUSES = {
  NOT_AVAILABLE: 0,
  TODAY: 1,
  NEXT_DAYS: 2,
  ONLY_PICKUP: 3,
  PRE_ORDER: 4
}

export default {
  IS_CHECKOUT,
  IS_PRODUCT,
  IS_SERVICES,
  IS_SHOPS,
  IS_CHECKOUT_SUCCESS,
  IS_MANAGER_CHECKOUT,
  USER_TYPE,
  MANAGER_TYPE,
  TRANSLATIONS_PARAMS,
  SHOPS_OPENED_STATUSES,
  SHOPS_FILTERS_FLAGS,
  COMMENTS,
  QUESTIONS,
  CART_STATUSES,
  MAP_PLACEMENTS,
  USER_DATA_KEY,
  ANALYTICS_USER_ID_KEY
}
